'use client';

import { useEffect } from "react";
import styles from "./ContactModal.module.css";

export default function ContactModal({ name, isOpen, onClose }) {
    // Fermer si clic en dehors du formulaire
    useEffect(() => {
        const handleClickOutside = (event) => {
            const modal = document.getElementById("contact-modal");
            if (isOpen && modal && !modal.contains(event.target)) {
                onClose();
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [isOpen, onClose]);

    if (!isOpen) return null;

    return (
        <div className={styles.overlay}>
            <div className={styles.modal} id="contact-modal">
                <button className={styles.closeButton} onClick={onClose}>×</button>
                <h2>Contactez-moi<br />{name}</h2>

                <form className={styles.form}>
                    <label>Prénom</label>
                    <input type="text" name="firstName" required />

                    <label>Nom</label>
                    <input type="text" name="lastName" required />

                    <label>Email</label>
                    <input type="email" name="email" required />

                    <label>Votre message</label>
                    <textarea name="message" rows="4" required></textarea>

                    <button type="submit" className={styles.submitButton}>Envoyer</button>
                </form>
            </div>
        </div>
    );
}
